<template>
  <v-app v-if="loading">
    <transition name="fade">
      <loading v-if="isLoading"></loading>
    </transition>
    <confirm ref="myConfirm"
             @clickFun="clickFun"></confirm>
    <template v-if="!$route.meta.allowAnonymous && $route.name !='Login' && $route.name != 'NewContentByAuthor'&& $route.name != 'ProductContentByAuthor'">
      <v-app id="inspire">
        <div class="app-container"
             ref="app-container">
          <toolbar :toolbarValue="toolbarValue"
                   @toggleNavigationBar="drawer = !drawer"
                   @doContact="doContact" />
          <v-content style="padding:0">
            <router-view @doContact="doContact"
                         @updateToolbarValue="updateToolbarValue" />
            <page-footer />
          </v-content>
        </div>
      </v-app>
    </template>
    <template v-if="$route.name =='Login' ||  $route.name == 'NewContentByAuthor' || $route.name == 'ProductContentByAuthor'">
      <transition>
        <keep-alive>
          <router-view @updateIsLogin="updateIsLogin"
                       :isLogin="isLogin" />
        </keep-alive>
      </transition>
    </template>
    <template v-if="$route.meta.allowAnonymous ">
      <v-app id="inspire">
        <div class="app-container"
             ref="app-container">
          <toolbar @toggleNavigationBar="drawer = !drawer"
                   :isLogin="'1'" />
          <v-content style="padding:0">
            <navigation :toggle="drawer"
                        @comfirm="comfirm"
                        :navigationValue="navigationValue"
                        @updateNavigationValue="updateNavigationValue" />
            <router-view @updateNavigationValue="updateNavigationValue" />
          </v-content>
        </div>
      </v-app>
    </template>
  </v-app>
</template>

<script>
import Loading from '@/components/core/Loading' //引入新闻列表分页 api 接口
export default {

  components: { Loading },

  name: 'App',
  watch: {
    $route: {
      handler (newValue) {
        this.loadNewPage();
        if (newValue.meta.allowAnonymous) {
          if (!sessionStorage.isLogin) {
            this.$refs.myConfirm.show("请登录", {})
          } else {
            this.isLogin = "1"
          }
        }
      },
      deep: true
    }
  },

  mounted () {
    this.isLoading = true;
    this.$store
      .dispatch("AddViewed")
      .then(() => {
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });
    this.loading = true;
  },

  data () {
    return {
      //顶部导航栏选中内容
      toolbarValue: 0,
      //左侧导航栏选中内容
      navigationValue: 0,
      drawer: true,
      isLogin: "0",
      loading: false,
      isLoading: false
    }
  },
  methods: {
    //滚动到底部
    doContact () {
      this.$nextTick(() => {
        let tablePar = this.$refs['app-container']
        window.scrollTo(0, tablePar.scrollHeight)
      })
    },
    // 滚动条回到页面顶端(x坐标, y坐标)
    loadNewPage () {
      window.scrollTo(0, 0);
    },
    //改变导航栏选中位置
    updateToolbarValue (num) {
      this.toolbarValue = num;
      this.isLogin = "1";
    },
    updateNavigationValue (num) {
      this.navigationValue = num;
    },
    //更新登陆标识
    updateIsLogin () {
      if (sessionStorage.isLogin) {
        this.isLogin = "1";
      } else {
        this.isLogin = '0';
      }

    },
    //打开退出提示框
    comfirm (str, obj) {
      this.$refs.myConfirm.show(str, obj)
    },
    //退出提示框中的函数
    clickFun (type) {
      if (type == "clickConfirm") {
        sessionStorage.clear();
        this.isLogin = '0';
        this.$router.push({ path: "/Login" });
      }
    }
  }
}
</script>

